/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Bright_Frog_StepInputs */

const en_teal_bright_frog_step = /** @type {(inputs: Teal_Bright_Frog_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read`)
};

const de_teal_bright_frog_step = /** @type {(inputs: Teal_Bright_Frog_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesen`)
};

/**
* | output |
* | --- |
* | "Read" |
*
* @param {Teal_Bright_Frog_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teal_bright_frog_step = /** @type {((inputs?: Teal_Bright_Frog_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Bright_Frog_StepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_teal_bright_frog_step(inputs)
	return de_teal_bright_frog_step(inputs)
});